module.exports = __webpack_public_path__ + "media/images/leaf-logo-766af4269cbfee547cb7d7dc25cbc69f.svg";